import { useState } from "react";
import { createContainer } from "unstated-next";

type User = {
  rawId: string;
  id?: string;
  hashedId?: string;
  token?: string;
  isAuthInvalid: boolean;
};

/**
 * ユーザー管理コンテナ
 */
const useUserContainer = () => {
  // URL の末尾44文字が暗号化されたID
  const path = window.location.pathname;
  const rawId = path.length >= 44 ? path.substr(-44) : "";
  const [user, setUser] = useState<User>({
    rawId: rawId,
    isAuthInvalid: false,
  });

  const setAuthenticatedUser = (
    userId: string,
    hashedUserId: string,
    apiToken: string
  ) => {
    user.id = userId;
    user.hashedId = hashedUserId;
    user.token = apiToken;
    setUser({ ...user });
  };

  const setAuthInvalid = () => {
    user.isAuthInvalid = true;
    setUser({ ...user });
  };

  return { user, setAuthenticatedUser, setAuthInvalid };
};

export const UserContainer = createContainer(useUserContainer);
